export const MENU_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Features', path: '/#feature' },
  { label: 'Pricing', path: '/#pricing' },
  { label: 'Education', path: '/#education' },
  { label: 'Download', path: '/#download' },
  { label: 'Blog', path: '/blog/1' },
];
